export default __webpack_public_path__ + "static/media/2de967028b73d3ad.ead8822028859cfa7a334325f67a0758.svg";